import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from '@material-ui/icons';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import FormTextInput from 'components/FormTextInput/FormTextInput';

import ModuleNotLoaded from './ModuleNotLoaded';

const OmniconvertModule = ({ classes, handleModuleUpdate, module }) => {
  const { t } = useTranslation();
  if (!module) {
    return <ModuleNotLoaded moduleName="OmniconvertModule" />;
  }

  return (
    <Fragment>
      <FormControlLabel
        control={
          <Checkbox
            checked={module.enabled}
            onChange={() =>
              handleModuleUpdate({
                ...module,
                enabled: !module.enabled,
              })
            }
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
              root: classes.checkRoot,
            }}
          />
        }
        label={t('brands.newBrandForm.omniconvert', 'Używaj Omniconvert')}
      />

      <FormTextInput
        tooltip={t('omniconvert.input.url.tooltip')}
        label="URL"
        classes={classes}
        name="url"
        value={module.url}
        handleChange={e =>
          handleModuleUpdate({
            ...module,
            url: e.target.value,
          })
        }
      />

      <FormTextInput
        label="ID"
        classes={classes}
        name="id"
        value={module.id}
        handleChange={e =>
          handleModuleUpdate({
            ...module,
            id: e.target.value,
          })
        }
      />
    </Fragment>
  );
};

export default OmniconvertModule;
